export const ROLE_OBJECT_TYPE = {
  ORGANIZATION: "organization",
  PROJECT: "project",
  TOUCHPOINT: "touchpoint",
  ENGAGEMENT_PROJECT: "engagement_plan",
  ENGAGEMENT_PLANS: "engagement_plans",
  TASK: "task",
  STAKEHOLDER: "stakeholder",
  STAKEHOLDER_GROUP: "stakeholder_group",
  CHAT_COMPLETION: "chatCompletion",
  ORGANIZATION_ISSUE: "organizationIssue",
  MANAGEMENT: "management",
  USER_GROUP: "user_group",
  NEWSLETTER: "newsletter",
  NETWORK: "network",
  TOUCHPOINT_SAVED_FILTER: "touchpoint_saved_filter",
  PLAN_SAVED_FILTER: "engagement_plan_saved_filter",
  TASK_SAVED_FILTER: "task_saved_filter",
  ENGAGEMENT_PROJECT_ACTIVITIES: "engagement_project_activities",
  SAVED_FILTER: "saved_filter",
  STAKEHOLDER_SAVED_FILTER: "stakeholder_saved_filter",
  DASHBOARDS: "dashboards",
} as const;
